import type { CSSProperties, PropsWithChildren } from 'react';
import styles from './Slide.module.css';

interface SlideProps {
  active?: boolean;
  /**
   * Visual variant. Most slides are `default`; `cover` and `closing` get
   * decorative radial gradients, `quote` gets centered alignment.
   */
  variant?: 'default' | 'cover' | 'closing' | 'quote';
  className?: string;
  style?: CSSProperties;
  /**
   * Optional grouping key. Consecutive slides sharing the same `group` are
   * treated as a single logical slide by DeckShell — one dot and one counter
   * position. Used for progressive build sequences where each step is its
   * own slide for reveal purposes but reads as one slide to the audience.
   */
  group?: string;
}

export default function Slide({
  active = false,
  variant = 'default',
  className = '',
  style,
  children,
}: PropsWithChildren<SlideProps>) {
  const variantClass = styles[variant] ?? '';
  return (
    <section
      className={`${styles.slide} ${variantClass} ${active ? styles.active : ''} ${className}`}
      style={style}
      aria-hidden={!active}
    >
      {children}
    </section>
  );
}
